import React from 'react';
import { Button } from './ui/button';
import { Heart, BookOpen, Stethoscope, Megaphone } from 'lucide-react';
import { siteData } from '../data/mock';

const iconMap = {
  Heart: Heart,
  BookOpen: BookOpen,
  Stethoscope: Stethoscope,
  Megaphone: Megaphone
};

const HelpSection = () => {
  return (
    <section id="help" className="py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-emerald-600 font-semibold text-sm uppercase tracking-wider mb-4">
            Make A Difference
          </span>
          <h2 className="text-4xl sm:text-5xl font-bold text-stone-800 mb-6">
            How You Can Help
          </h2>
          <p className="text-lg text-stone-600 max-w-2xl mx-auto">
            Your donation will directly support Jamaican workers and families. 
            Every contribution, big or small, helps uplift lives and strengthen communities.
          </p>
        </div>

        {/* Donation Uses Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {siteData.donationUses.map((item, index) => {
            const IconComponent = iconMap[item.icon];
            
            return (
              <div
                key={item.id}
                className="group bg-white rounded-2xl p-8 border border-stone-200 hover:border-emerald-200 hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
              >
                {/* Icon */}
                <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-emerald-50 to-emerald-100 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                  <IconComponent className="w-8 h-8 text-emerald-600" />
                </div>

                {/* Content */}
                <h3 className="text-lg font-bold text-stone-800 mb-3">
                  {item.title}
                </h3>
                <p className="text-stone-600 text-sm leading-relaxed">
                  {item.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Image & CTA Section */}
        <div className="relative rounded-3xl overflow-hidden">
          <img
            src={siteData.images.unity}
            alt="Hands united in solidarity"
            className="w-full h-80 object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-stone-900/90 via-stone-900/70 to-transparent" />
          
          <div className="absolute inset-0 flex items-center">
            <div className="px-8 sm:px-12 max-w-xl">
              <h3 className="text-3xl sm:text-4xl font-bold text-white mb-4">
                Together We Can Build A Better Jamaica
              </h3>
              <p className="text-white/80 mb-8">
                Where workers are fairly compensated, fairly taxed, and fairly treated — 
                with access to the healthcare and leadership accountability they deserve.
              </p>
              <Button
                asChild
                size="lg"
                className="bg-amber-500 hover:bg-amber-400 text-stone-900 font-bold px-8 shadow-xl hover:shadow-2xl transition-all hover:scale-105"
              >
                <a href={siteData.donateUrl} target="_blank" rel="noopener noreferrer">
                  <Heart className="w-5 h-5 mr-2" />
                  Donate on GoFundMe
                </a>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HelpSection;
